<template>

  <b-card>
    <b-form
      class="m-2"
      @submit.prevent="fetchOTP"
    >
      <div class="d-flex">
        <div
          style="width: 40%"
          class="d-flex flex-column"
        >
          <div>
            <label for="otp">Phone Number</label>
            <b-form-input
              id="otp"
              v-model="phoneNumber"
              type="number"
              required
              :disabled="loading"
            />
          </div>
          <div
            v-if="showLastOTP"
            class="d-flex justify-content-center mt-2"
          >
            <b-spinner
              v-if="loading"
              variant="primary"
            />
            <h4
              v-else
            >
              Last OTP : <span style="color: green"> {{ lastOTP ? lastOTP : 'No matching OTP found' }}</span>
            </h4>
          </div>
        </div>
        <div>
          <b-button
            :disabled="loading"
            variant="primary"
            type="submit"
            class="ml-3 mt-2"
          >
            <span>Get OTP</span>
          </b-button>
        </div>

      </div>

    </b-form>
  </b-card>

</template>
<script>
import {
  BCard, BFormInput, BButton, BSpinner, BForm,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driverStore from '../driverStoreModule'

export default {
  components: {
    BCard, BFormInput, BButton, BSpinner, BForm,
  },
  setup(_, ctx) {
    useRegisterStoreModule('drivers', driverStore)
    const phoneNumber = ref()
    const loading = ref(false)
    const showLastOTP = ref(false)
    const lastOTP = ref()
    const fetchOTP = async () => {
      try {
        loading.value = true
        showLastOTP.value = true
        lastOTP.value = (await ctx.root.$store.dispatch('drivers/fetchLastOtp', phoneNumber.value))?.data?.data?.data?.otp_code
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }

    return {
      phoneNumber,
      fetchOTP,
      loading,
      lastOTP,
      showLastOTP,
    }
  },
}
</script>
